/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import { formValue } from "../../../services/formServiceFunctions";
import useForm from "../../../hooks/useForm";
import ValidatorForm from "../../Validator/ValidatorForm";
import SubmitButton from "../../Button/SubmitButton";
import _ from "lodash";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import ValidatorNumberField from "../../Validator/ValidatorNumberField";
import { Box } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const IncomeEmployment = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const initialValues = {
    hasIncomeEmployment: pcs.hasIncomeEmployment,
    incomeEmploymentAmount: pcs.incomeEmploymentAmount,
  };

  const { values, errors, handleChange, handleSubmit, handleBlur, registerValidators, touchedValues } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Lohn</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Erhalten Sie als Angestellter Lohn oder Gehalt?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorSelect
              label={"Lohn oder Gehalt?"}
              name={"hasIncomeEmployment"}
              value={formValue(values, "hasIncomeEmployment")}
              onChange={handleChange}
              onBlur={handleBlur}
              registerValidators={registerValidators}
              dependentValidationFields={["incomeEmploymentAmount"]}
            >
              <MenuItem value={"no"}>Nein</MenuItem>
              <MenuItem value={"yes"}>Ja</MenuItem>
            </ValidatorSelect>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorNumberField
              fieldType={"money"}
              numberType={"float"}
              fullWidth={true}
              id="incomeEmploymentAmount"
              name="incomeEmploymentAmount"
              label="Mtl. Bruttobetrag"
              onBlur={handleBlur}
              registerValidators={registerValidators}
              isHighlighted={formValue(values, "hasIncomeEmployment") === "yes"}
              error={!!errors["incomeEmploymentAmount"]}
              helperText={errors["incomeEmploymentAmount"]}
              margin="normal"
              value={formValue(values, "incomeEmploymentAmount")}
              onChange={handleChange}
              disabled={formValue(values, "hasIncomeEmployment") !== "yes"}
            />
          </Grid>
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default IncomeEmployment;
